import { lane } from "./marquee.module.css"
import Promo from "../promo/promo"

const Marquee = (props) => {
  const { content } = props

  return (
    <div className={lane} style={{ "--numItems": content.length }}>
      {content.map(({ title, label, link }) => (
        <Promo title={title} label={label} link={link} key={`${link}${label}`} />
      ))}
      {/* duplicated to ensure it looks continuous */}
      {content.map(({ title, label, link }) => (
        <Promo title={title} label={label} link={link} key={`${link}${label}_dup`} />
      ))}
    </div>
  )
}

export default Marquee
